import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ProgrammeRecommendations from '../../widgets/ProgrammeRecommendations';
import LoadingSpinner from '../../blocks/LoadingSpinner';
import programmeService from '../../../services/programmeService';
import { PROMO_DEMO_DSE_SCORES, PROMO_FALLBACK_PROGRAMMES } from '../../../data/promotionalHomeDemo';
import { promoEmbedBodyClass, promoEmbedShellClass } from './PromotionalEmbedCta';

const PromotionalProgrammeRecommendationsEmbed = () => {
  const { t } = useTranslation();
  const [programmes, setProgrammes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [usedFallback, setUsedFallback] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        await programmeService.initialize();
        const collectionsResult = await programmeService.getAvailableCollections();
        if (collectionsResult.success && collectionsResult.data?.length) {
          programmeService.setCollection(collectionsResult.data[0]);
        }

        const result = await programmeService.getRecommendationsByClassification(
          PROMO_DEMO_DSE_SCORES,
          [],
          programmeService.currentCollection,
          [],
          5,
          6
        );

        if (!cancelled && result.success && result.data?.length) {
          setProgrammes(result.data.slice(0, 2));
          setUsedFallback(false);
          return;
        }
      } catch (err) {
        console.error('Promotional recommendations embed:', err);
      }

      if (!cancelled) {
        setProgrammes(PROMO_FALLBACK_PROGRAMMES);
        setUsedFallback(true);
      }
    };

    load().finally(() => {
      if (!cancelled) setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className={promoEmbedShellClass}>
      <div className={promoEmbedBodyClass}>
        {loading && (
          <div className="flex h-full min-h-[280px] items-center justify-center py-6">
            <LoadingSpinner size="small" text={t('jupa.loadingProgrammeRecommendations')} showText />
          </div>
        )}

        {!loading && (
          <>
            {usedFallback && (
              <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2 py-1.5 mb-3 dark:text-amber-100 dark:bg-amber-950/40 dark:border-amber-800/60">
                {t('promotionalHome.embed.recommendationsFallback')}
              </p>
            )}
            <ProgrammeRecommendations
              embedded
              maxVisible={2}
              interactive={false}
              recommendedProgrammes={programmes}
              selectedProgrammes={[]}
              onAddProgramme={() => {}}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PromotionalProgrammeRecommendationsEmbed;
